export default __webpack_public_path__ + "static/florencefrancey-3028052c95dfde8403fc81718d1d374b.png";